import { Component, Host, h, Prop, Event, EventEmitter, Element } from '@stencil/core';
import { hasSlot } from '../../utils';
import { BreadcrumbsVariant } from '../breadcrumbs/breadcrumbs-interface';

/**
 * @slot - Main content of the breadcrumbs-item.
 * @slot separator - Used for custom separator. Most probably will be used with o2-icon.
 *
 * @part item - Main breadcrumbs-item container.
 * @part link - Anchor tag inside breadcrumbs-item.
 * @part sepatator - Separator icon inside breadcrumbs-item.
 */
@Component({
  tag: 'o2-breadcrumbs-item',
  styleUrl: 'breadcrumbs-item.scss',
  shadow: true,
})
export class O2BreadcrumbsItem {
  private hasSeparatorSlot: boolean;

  @Element() private el!: HTMLO2BreadcrumbsItemElement;

  /**
   * Url of breadcrumbs-item
   */
  @Prop() href?: string;

  /**
   * Emitted everytime when component did render
   */
  @Event() o2Ready!: EventEmitter<any>;

  private isOnlyChild = () => {
    return this.el.parentElement.children.length === 1;
  }

  private isLastChild = () => {
    return this.el.parentElement.children.length === Array.from(this.el.parentElement.children).indexOf(this.el) + 1;
  }

  private getBreadcrumbsVariant = () => {
    return this.el.parentElement.getAttribute('color') || this.el.parentElement.getAttribute('variant') as BreadcrumbsVariant;
  }

  connectedCallback() {
    this.hasSeparatorSlot = hasSlot(this.el, '[slot="separator"]');
  }

  componentDidRender = () => {
    this.o2Ready.emit();
  };

  render() {
    const variant = this.getBreadcrumbsVariant();

    const isOnlyChild = this.isOnlyChild();
    const isLastChild = this.isLastChild();

    return (
      <Host>
        <div class={`breadcrumbs-item breadcrumbs-item--${variant} ${isOnlyChild? 'breadcrumbs-item--orphan': ''} ${!isOnlyChild && isLastChild ? 'breadcrumbs-item--last-child': ''} `} part="item">
          <a class="breadcrumbs-item__link" href={this.href} part="link">
            <slot />
          </a>

          <div class="breadcrumbs-item__separator" part="separator">
            {this.hasSeparatorSlot ? (
              <slot name="separator" />
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M11.1921 7.63626C11.393 7.8371 11.393 8.16273 11.1921 8.36357L6.04928 13.5064C5.84844 13.7073 5.52282 13.7073 5.32197 13.5064C5.12113 13.3056 5.12113 12.98 5.32197 12.7791L10.1012 7.99992L5.32198 3.22071C5.12113 3.01987 5.12113 2.69425 5.32198 2.4934C5.52282 2.29256 5.84844 2.29256 6.04928 2.4934L11.1921 7.63626Z"
                  fill="currentColor"
                />
              </svg>
            )}
          </div>
        </div>
      </Host>
    );
  }
}
